import { sanitizeHtml } from '../../utils/sanitizeHtml';
import {
  autoFormatMarkdownFromPlainText,
  shouldAutoFormatMarkdown,
} from '../../utils/autoFormatMarkdown';
import MarkdownContent from './MarkdownContent';

function looksLikeHtml(value) {
  const s = String(value || '').trim();
  if (!s) return false;
  // Quick heuristic: contains a tag-like pattern
  return /<\/?[a-z][\s\S]*>/i.test(s);
}

function RichContent({ content, className = '', forceAutoFormat = false }) {
  const raw = String(content || '').trim();
  const value =
    forceAutoFormat || shouldAutoFormatMarkdown(raw)
      ? autoFormatMarkdownFromPlainText(raw)
      : raw;
  if (!value) return null;

  if (looksLikeHtml(value)) {
    let safe = '';
    try {
      safe = sanitizeHtml(value);
    } catch (err) {
      // If sanitization fails for any reason, fall back to rendering as text.
      // eslint-disable-next-line no-console
      console.warn('sanitizeHtml failed, falling back to plain text render', err);
      safe = '';
    }
    if (!safe) {
      const textFallback = value.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      return <MarkdownContent content={textFallback || value} className={className} />;
    }
    return (
      <div
        className={`markdown ${className}`.trim()}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: safe }}
      />
    );
  }

  return <MarkdownContent content={value} className={className} />;
}

export default RichContent;


